import React from 'react'
import { useContext } from "react"
import { Grid, Card, CardContent, Typography, Box } from "@mui/material"
import UserContextP from "Interfaces/Context"

interface PropsInterface {
    order: any
    color: string
}

const InformationDocument = (props: PropsInterface) => {
    const { order, color } = props
    const context = useContext(UserContextP)

    const totalLines = Number(order?.totalLines ?? 0)
    const discountPct = Number(order?.discount ?? 0)
    const discountValue = Math.round((totalLines * discountPct / 100) * 100) / 100
    const subtotal = Number(order?.subtotal ?? 0)
    const iva = Math.round((subtotal * 0.13) * 100) / 100
    const retention = Number(order?.retention ?? 0)
    const total = Number(order?.total ?? 0)

    const currency = process.env.REACT_APP_CURRENCY ?? '$'
    const fmt = (v: number) => `${currency} ${context.separatorMiles(v)} `

    return (
        <>
            <Grid item xs={12}>
                <Box sx={{ bgcolor: color, color: '#fff', p: 1, borderRadius: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Información del documento</Typography>
                </Box>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">Total Líneas</Typography>
                        <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{fmt(totalLines)}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">Descuento %</Typography>
                        <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{discountPct.toFixed(2)}%</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">Descuento $</Typography>
                        <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{fmt(discountValue)}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">Subtotal</Typography>
                        <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{fmt(subtotal)}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">IVA</Typography>
                        <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{fmt(iva)}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">Retención</Typography>
                        <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>{fmt(retention)}</Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={6}>
                <Card elevation={0} sx={{ borderRadius: 0 }}>
                    <CardContent sx={{ py: 1 }}>
                        <Typography variant="body2" color="text.secondary">Total del documento</Typography>
                        <Typography variant="h6" sx={{ textAlign: 'right' }}>{fmt(total)}</Typography>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}

export default InformationDocument